export const PERMISSIONS = {

    CAJA_VIEW: 'caja_view',
    CAJA_EDIT: 'caja_edit',
    CAJA_COBRO: 'caja_cobro',
    CIERRE_TESORERIA_VIEW: 'cierre-tesoreria_view',
    CIERRE_TESORERIA_EDIT: 'cierre-tesoreria_edit',
    RECAUDACION_LOTE_VIEW: 'recaudacion-lote_view',
    RECAUDACION_LOTE_EDIT: 'recaudacion-lote_edit',
    RECAUDACION_LOTE_CONTROL: 'recaudacion-lote_control',
    RECAUDACION_LOTE_CONCILICION: 'recaudacion-lote_conciliacion',
    PAGO_RENDICION_VIEW: 'pago-rendicion-lote_view',
    PAGO_RENDICION_EDIT: 'pago-rendicion-lote_edit',
    REGISTRO_CONTABLE_LOTE_VIEW: 'registro-contable-lote_view',
    REGISTRO_CONTABLE_LOTE_EDIT: 'registro-contable-lote_edit',
    LISTAS_TESORERIA_VIEW: 'listas_tesoreria_view',
    LISTAS_TESORERIA_EDIT: 'listas_tesoreria_edit',
    DEVOLUCION_LOTE_VIEW: 'devolucion-lote_view',
    DEVOLUCION_LOTE_EDIT: 'devolucion-lote_edit',
    PROCESO_VIEW: 'proceso_view',
    PROCESO_EDIT: 'proceso_edit',

};
